import http from '@/services/http'
import { pickBy, identity } from 'lodash'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    events: [],
    page: null,
    totalCount: null,
  },
  mutations: {
    startFetch(state) {
      state.fetchInProgress = true
    },
    stopFetch(state) {
      state.fetchInProgress = false
    },
    setListData(state, { events, count }) {
      state.events = events
      state.totalCount = count
    },
  },
  actions: {
    async fetch({ commit }, opts) {
      opts = opts || {}
      let params = { page: 1, ...opts }
      params = pickBy(params, identity)
      commit('startFetch')
      const response = await http.getAuthed('/cq/events', params)
      commit('setListData', {
        events: response.data.results,
        count: response.data.count,
      })
      commit('stopFetch')
    },
  },
}
